import * as React from "react";
import { Icon } from "@chakra-ui/react";
const Internal = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 20 20", ...props }, /* @__PURE__ */ React.createElement("path", { fill: "#fff", d: "M14.6 3h2.454l-5.36 6.065L18 17.315h-4.937l-3.867-5.004-4.425 5.005H2.316l5.733-6.487L2 3h5.063l3.495 4.574zm-.86 12.863h1.36L6.323 4.377H4.865z" }));
const SvgXDarkmode = (props) => {
  return /* @__PURE__ */ React.createElement(Icon, { as: Internal, ...props });
};
export default SvgXDarkmode;
